var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('img',{attrs:{"src":require("../../../static/images/dz.png")}}),_c('div',{staticClass:"dznum"},[_vm._v(_vm._s(_vm.likeCount))]),_c('div',{staticClass:"praise_bubble",attrs:{"id":"praise_bubble"}})])}
var staticRenderFns = []

export { render, staticRenderFns }